import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { MerchCardBadge } from 'pricing-pages-ui-components/badges/MerchCardBadge';
import { useAppSelector } from '../../../reducers';
import { isUngatedForInbound25Selector } from '../../../selectors/GatingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const CurrentTrialBadge = ({
  message = 'pricing-pages-ui.merchCardsV2.badges.CURRENT_TRIAL'
}) => {
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  if (isUngatedForInbound25) {
    return /*#__PURE__*/_jsx(MerchCardBadge, {
      translationKey: message,
      isAppAuth: true,
      badgeColor: "fill-surface-default",
      borderColor: "border-core-pressed",
      textColor: "text-core-default"
    });
  }
  return /*#__PURE__*/_jsx(View, {
    position: "absolute",
    insetBlockStart: "0",
    insetInlineStart: "0",
    children: /*#__PURE__*/_jsx(Tag, {
      use: "default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      })
    })
  });
};